import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'valueOrDash',
  standalone: true,
})
export class ValueOrDashPipe implements PipeTransform {
  transform(value: string | number | null | undefined): string | number {
    if (value === null || value === undefined || value === '') {
      return '-';
    }

    return value;
  }
}
